import { useSyncExternalStore } from 'react';
import { subscribeSessionChanges } from './useSessionIdentity';
import { readViewerOpinion, subscribeViewerOpinions } from '../utils/viewerOpinionState';

const subscribe = notify => {
  const stopOpinions = subscribeViewerOpinions(notify);
  const stopSession = subscribeSessionChanges(notify);
  return () => { stopOpinions(); stopSession(); };
};
export default function useViewerOpinion(storyId) {
  return useSyncExternalStore(subscribe, () => readViewerOpinion(storyId), () => undefined);
}
